import axios from "axios";
import { METADATA_URL } from "../utils";

export const fetchMetadata = () => {
  return axios.get(METADATA_URL);
};
